// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FloatingArea_wrapper__nQ0ga"};